import React from 'react';

import { ArchivalAidMetadata, ArchivalCollection } from 'types';
import { ApiRoute, GridBodyType, PageKey, UrlRoute } from 'enums';
import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';

import { ArchivalAidDetail } from './archival-aid-detail';
import { ArchivalAidOrder } from './archival-aid-order';
import { ArchivalAidFavourite } from './archival-aid-favourite';
import { ArchivalAidQuote } from './archival-aid-quote';
import { ArchivalAidDownload } from './archival-aid-download';
import { archivalAidChildrenConfig } from './archival-aid-children/archival-aid-children-grid';
import { eadConfig } from './archival-aid-children/ead-grid-config';

export const archivalAidConfig: GridEntityConfig<
  ArchivalCollection,
  ArchivalAidMetadata
> = {
  id: 'pomucky',
  title: 'Pomůcky',
  getParent: (item) => item?.archivalCollection!,
  getLabel: (item) => item.name ?? '',
  getId: (item) => item.id,
  getChildrenFilter: (item) => ({
    field: 'describingArchivalAids.id',
    operation: 'EQ',
    value: item.id,
  }),
  params: {
    size: 500,
  },
  listApi: '/api/archival-aid-metadata/list',
  urlRoute: UrlRoute.ARCHIVAL_AID,
  apiRoute: ApiRoute.ARCHIVAL_AID,
  pageKey: PageKey.DETAIL_ARCHIVAL_AID,
  icon: 'menu_book',
  archivalAidLevel: 0,
  ActionButtons: actionButtonsFactory([
    { id: 'favourite', Component: ArchivalAidFavourite },
    { id: 'download', Component: ArchivalAidDownload },
    { id: 'order', Component: ArchivalAidOrder },
    { id: 'quote', Component: ArchivalAidQuote },
  ]),
  bodyComponents: {
    [GridBodyType.DETAIL]: ArchivalAidDetail,
  },
};

export const archivalAidGridConfig: any[] = [
  archivalAidConfig,
  archivalAidChildrenConfig,
  eadConfig,
];

export const ArchivalAidGrid = () => (
  <Grid gridConfig={archivalAidGridConfig} />
);
